import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getArticleDetails } from "../api/getArticleDetails";
import { ArticleBrandId, ArticleCategory, ArticleGroupIds } from "../types";

const QUERY_KEY = "article-details";

type Params = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
  groupId: ArticleGroupIds;
  articleId: string;
};

export const useArticleDetailsQuery = ({
  brandId,
  categoryId,
  groupId,
  articleId,
}: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY, { brandId, categoryId, groupId, articleId }],
    queryFn: async () => {
      return await getArticleDetails(brandId, categoryId, groupId, articleId);
    },
    enabled: !!articleId,
    staleTime: 0,
  });
};

export const invalidateArticleDetailsQuery = ({
  brandId,
  categoryId,
  groupId,
  articleId,
}: Params) => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEY, { brandId, categoryId, groupId, articleId }],
  });
};
